<template>
    <ds-card
        class="unlayer-template-card"
    >
        <header v-if="showHeader" class="template-card-header">
            <div class="title">
                {{ templateGroup.title }}
            </div>

            <div v-if="$slots.menu" ref="menu" class="menu">
                <slot name="menu" />
            </div>
        </header>
        <div v-if="loading" class="placeholder">
            <ds-placeholder
                :rows="[
                    { height: '2rem', boxes: [3, 1] },
                    { height: '3.5rem', boxes: [1] },
                    { height: '3.5rem', boxes: [1] },
                ]"
            />
        </div>

        <template v-if="!loading">
            <div class="thumbnail-container">
                <img
                    v-if="templateGroup.htmlPreviewUrl"
                    class="template-thumbnail"
                    :src="templateGroup.htmlPreviewUrl"
                    :alt="templateGroup.title"
                />
                <div v-else class="no-thumbnail">
                    No Preview Available
                </div>
                <div v-if="showSelect" class="template-details">
                    <ds-filled-button class="preview-button" @click="$emit('select')">
                        <span>{{ $options.SELECT }}</span>
                    </ds-filled-button>
                    <ds-filled-button v-if="templateGroup.htmlPreviewUrl" class="preview-button" @click="$emit('preview')">
                        <span>{{ $options.PREVIEW }}</span>
                    </ds-filled-button>
                </div>
            </div>
        </template>
    </ds-card>
</template>

<script>
export const SELECT = 'Select template';
export const PREVIEW = 'Preview';

export default {
    SELECT,
    PREVIEW,

    props: {
        templateGroup: {
            type: Object,
            required: true,
        },
        isPreviewing: {
            type: Boolean,
            required: true,
        },
        forceLoaded: Boolean,
        showHeader: {
            type: Boolean,
            default: true,
        },
        refreshImage: {
            type: Boolean,
            default: false,
        },
        showSelect: {
            type: Boolean,
            default: false,
        },
        loadImageDelay: {
            type: Number,
            default: 12000,
        },
    },

    data() {
        return {
            loading: true,
        };
    },

    mounted() {
        if (this.refreshImage) {
            this.loading = true;
            setTimeout(() => this.addRandomAttribute(), this.loadImageDelay);
        } else {
            this.loading = false;
        }
    },

    methods: {
        addRandomAttribute() {
            this.templateGroup.previewUrl = this.templateGroup.previewUrl.concat('?rand=', Math.random().toString());
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
$card-size: 15.75rem;
.unlayer-template-card {
    padding: 0;
    position: relative;
}

.no-thumbnail {
    margin-top: 150px;
    text-align: center;
}

.template-details {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: $color-paper-900;
}

.preview-button {
    margin-bottom: $spacing-100;
}

.thumbnail-container {
    &:hover {
        .template-details {
            margin-top: 3rem;
            display: flex;
        }
    }
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  max-height: $card-size;
  overflow: hidden;
}

.template-card-header {
    background: $color-paper;
    color: $color-ink-900;
    border-bottom: 1px solid $color-ink-100;
    top: 0;
    left: 0;
    right: 0;
    height: px-to-rem(48);
    text-overflow: ellipsis;
    padding: px-to-rem(12);
    z-index: 3;
    display: flex;
    align-items: center;
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
}

.template-gallery-html-card:not(:hover) .template-details {
    display: none;
}

.title {
    font-weight: 700;
    line-height: $line-height-sm;
    flex: 1;
    max-width: calc(100% - #{$spacing-400});
}

.placeholder {
    padding: $spacing-200;
}
</style>
